module.exports = __webpack_public_path__ + "static/media/rbs.28504ea0.png";